import { ListView } from "../ListView"
import { ListColumn } from "../ListColumn";
import { ItemFinderListView } from "../../ItemFinderListView";

export class MeddraListView extends ItemFinderListView {

    constructor(items: any, itemFinderArrayColumns: ListColumn[],itemFinderTreeColumns: ListColumn[]) {
        super(items,itemFinderArrayColumns,itemFinderTreeColumns);
    }
}